import {getApiConfig} from '../utilities';
import {setResetPasswordPopup, loadingDialog_show} from "./A_Popups";

export const resetPassword = (data) => {
  return (dispatch, getState) => {
    dispatch(loadingDialog_show(true, 'Loading...', 'Please wait while we prepare an email'));
    const {auth, asCustomer} = getState();
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    if (fabricatorId) {
      data.fabricatorId = fabricatorId;
    }
    return getApiConfig('Auth/SendResetCustomerPasswordEmail')
      .post(data)
      .then((response) => {
        dispatch(setResetPasswordPopup({
          resetPasswordSuccess: !response.__error__
        }));
        dispatch(loadingDialog_show(false));
        return response
      })
  }
};

export const changePassword = (data) => {
  return dispatch => {
    dispatch(loadingDialog_show(true, 'Loading...', 'Please wait while we change your password'));
    getApiConfig('Users/ResetCustomerPassword')
      .post(data)
      .then((response) => {
        dispatch(setResetPasswordPopup({
          changePasswordSuccess: !response.__error__
        }));
        dispatch(loadingDialog_show(false));
      })
  }
};

